import { useAppSelector } from 'Douleutaras/redux/hooks';
import { jobSelectors } from 'Douleutaras/redux/data/jobs/jobsSlice';
import { getRelationEntitiesFromSingleEntity } from 'Douleutaras/redux/data/jobAttributes/jobAttributesSelectors';
import { BidFetchEndpoint } from 'Douleutaras/redux/data/jobBids/jobBidsSlice';
import { usersSelector } from 'Douleutaras/redux/data/users/usersSlice';
import { JSONApiDataObject, UserV2 } from 'Douleutaras/types/index';

interface ExtractSellerInfoFromJobResult {
  user: JSONApiDataObject<UserV2>;
  conversationId: string;
}

// Extracts UserV2 object and conversationId to a single Object from a jobId
export const useExtractSellerInfoFromJob = ({ jobId }: { jobId: string }): Array<ExtractSellerInfoFromJobResult> => {
  const selectJobBids = getRelationEntitiesFromSingleEntity(
    state => jobSelectors.selectById(state, parseInt(jobId, 0)),
    state => state.jobBids?.meta?.[BidFetchEndpoint(jobId)]?.data || [],
    'bids');
  const jobBids = useAppSelector(state => selectJobBids(state));
  const users = useAppSelector(state => usersSelector.selectAll(state));

  return jobBids.map(jobBid => ({
    user: users.find(user => user.id === jobBid.relationships.seller.data.id),
    conversationId: jobBid.relationships.conversation.data?.id
  }));
};
